import { cloneDeep, isEqual } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { GenerateButton, GenerateButtonMemri } from '../styledComponents';
// import AvailablePropCodes from './components/AvailablePropCodes';
import SelectedPropCodes from './components/SelectedPropCodes';
import {
  createPropCode,
  getDmaMarkets,
  getPropCodeTypes,
  setEditSelectedPropCode,
} from '../../../actions/entitlementActions';
import PortalModal from '../../common/Modal/PortalModal';
import { useDispatch, useSelector } from '../../common/react-redux-hooks';
import PropCodeGenerate from './PropCodeGenerate';
import { mapPropCode } from '../../../util/ContractAdminUtils';
import SelectedMEMRIUsers from './components/SelectedMEMRIUsers';
import SelectedMRIMarkets from './components/SelectedMRIMarkets';
import { enableInDevOnly } from '../../../util/CommonUtils';

const propCodemodalStyles = {
  left: '30%',
  top: '10%',
  width: '450px',
  height: '674px,',
};
const PropCode = ({
  openMarketPopup,
  markets,
  setSelProps,
  setPropCodeChanged,
  reset,
  memriUserDtos,
  marketList,
  setEditProps,
  setPropChanged,
  propData,
  memriData,
  mriMarketData,
  editProps,
  setNewPropCode,
}) => {
  const dispatch = useDispatch();
  const {
    propCodeTypes,
    selectedContractId,
    propCodes,
    editSelectedPropCode,
    editSelectedMRIMarket,
    editSelectedMEMRIUser,
  } = useSelector(state => ({
    propCodeTypes: state.contractAdmin.propCodeTypes,
    selectedContractId: state.contractAdmin.selectedContractId,
    propCodes: state.contractAdmin.propCodes,
    editSelectedPropCode: state.contractAdmin.editSelectedPropCode,
    editSelectedMRIMarket: state.contractAdmin.editSelectedMRIMarket,
    editSelectedMEMRIUser: state.contractAdmin.editSelectedMEMRIUser,
    editEntMemri: state.contractAdmin.editEntMemri,
  }));
  const [marketCount, setMarketCount] = useState('');
  const [propCodeError, setPropCodeError] = useState('');
  const [availablePropCodes, setAvailablePropCodes] = useState();
  const [selectedPropCodes, setSelectedPropCodes] = useState([]);
  const [selectedMEMRIUser, setSelectedMEMRIUser] = useState([]);
  const [selectedMRIMarket, setSelectedMRIMarket] = useState([]);
  const [filteredPropCodes, selFilteredPropCodes] = useState([]);
  const localDevAndQaEnv = enableInDevOnly()
  useEffect(() => {
    // dispatch(getDmaMarkets());
    setAvailablePropCodes(cloneDeep(propCodes));
    setSelectedPropCodes(propData);
  }, [propCodes]);

  useEffect(() => {
    if (!reset) {
      setSelectedPropCodes(cloneDeep([...propData]));
      setSelectedMEMRIUser(cloneDeep([...memriUserDtos]));
      setSelectedMRIMarket(cloneDeep([...mriMarketData]));
    }
  }, [propData, memriUserDtos, mriMarketData]);

  useEffect(() => {
    if (reset) {
      const selPropCode = [...editSelectedPropCode];
      const selMemriUser = [...memriData];
      const selMRIMarket = [...marketList];
      setSelectedPropCodes(selPropCode);
      setSelectedMEMRIUser(selMemriUser);
      setSelectedMRIMarket(selMRIMarket);
      // setSelProps(selPropCode);
    }
  }, [reset]);

  useEffect(() => {
    if (memriUserDtos) {
      const selected = [...memriUserDtos];
      setSelectedMEMRIUser(selected);
    }
  }, [memriUserDtos]);

  // useEffect(() => {
  //   if (marketList) {
  //     const selected = [...marketList];
  //     setSelectedMRIMarket(selected);
  //   }
  // }, [marketList]);

  useEffect(() => {
    let editObj = cloneDeep(editSelectedPropCode);
    editObj = editObj ? editObj.sort((a, b) => a.id - b.id) : [];
    let selectedObj = cloneDeep(selectedPropCodes);
    selectedObj = selectedObj ? selectedObj.sort((a, b) => a.id - b.id) : [];
    setPropCodeChanged(isEqual(mapPropCode(editObj), mapPropCode(selectedObj)));
    // setSelProps(cloneDeep(selectedPropCodes));
  }, [selectedPropCodes]);

  useEffect(() => {
    if (markets.length) {
      const selectedMarket = markets.find(data => data.studySource === 2);
      if (selectedMarket) {
        setMarketCount(selectedMarket.ids.length);
      } else {
        setMarketCount('');
      }
    } else {
      setMarketCount('');
    }
  }, [markets]);

  useEffect(() => {
    const ids = [];
    editSelectedPropCode.map(item => ids.push(item.id));
    const propObj = [{ id: ids }];
    setEditProps(propObj);
  }, [editSelectedPropCode]);

  useEffect(() => {
    const response = editSelectedPropCode.map(item => item.id);
    selFilteredPropCodes(response);
  }, [editSelectedPropCode]);

  const [isGeneratePropPopUp, setIsGeneratePropPopUp] = useState(false);
  const IsClosePropCodePopup = () => {
    setPropCodeError('');
    setIsGeneratePropPopUp(false);
  };
  const openGeneratePopUp = () => {
    setPropCodeError('');
    setPropChanged(true);
    if (!propCodeTypes.length) {
      dispatch(getPropCodeTypes());
    }
    setIsGeneratePropPopUp(true);
  };
  // const updateSelectedPropCodes = data => {
  //   setSelectedPropCodes([...data]);
  // };
  const generatePropCode = data => {
    const req = {
      contractId: selectedContractId,
      ...data,
    };
    dispatch(createPropCode(req)).then(res => {
      if (res.data) {
        setIsGeneratePropPopUp(false);
        const selPropCodes = cloneDeep(selectedPropCodes);
        editProps.map(item => item.id.push(res.data.newPropCode.id));
        selPropCodes.unshift(res.data.newPropCode);
        propData.push(res.data.newPropCode);
        setNewPropCode([res.data.newPropCode]);
        setPropChanged(false);
        setSelectedPropCodes([...selPropCodes]);
      } else {
        setPropCodeError(res.error);
      }
    });
  };

  return (
    <Fragment>
      <div className="PropCode-Content">
        <div className="button-holder">
          <div className="generate">
            <GenerateButton
              height="36px"
              onClick={() => openMarketPopup({ optionName: '' })}
            >
              MRI Market
            </GenerateButton>
          </div>
          {/* <div className="generate">
            <GenerateButton onClick={() => openGeneratePopUp()}>
              {' '}
              Generate{' '}
            </GenerateButton>
          </div> */}
          <div className="generate">
            <GenerateButton
              onClick={() => openMarketPopup({ optionName: 'MEMRI-USERS' })}
            >
              MEMRI Users
            </GenerateButton>
          </div>
        </div>
        <div className="button-holder">
          <div className="generate">
            <GenerateButtonMemri
              onClick={() =>
                openMarketPopup({
                  optionName: 'PROP-CODE',
                  availablePropCodes,
                  filteredPropCodes,
                })
              }
            >
              Prop Code
            </GenerateButtonMemri>
          </div>
          <div className="generate">
            <GenerateButtonMemri
              onClick={() => openGeneratePopUp()}
              disabled={!localDevAndQaEnv}
            >
              New Prop Code
            </GenerateButtonMemri>
          </div>
        </div>
        <SelectedMRIMarkets selectedPropCodes={selectedMRIMarket} />
        <SelectedMEMRIUsers selectedPropCodes={selectedMEMRIUser} />
        <SelectedPropCodes selectedPropCodes={selectedPropCodes} />
        {/* <AvailablePropCodes
          availablePropCodes={availablePropCodes}
          selectedPropCodes={selectedPropCodes}
          updateSelectedPropCodes={updateSelectedPropCodes}
        /> */}
      </div>
      {isGeneratePropPopUp && (
        <PortalModal
          title="Prop Code Generate"
          isShowing={isGeneratePropPopUp}
          dialogStyles={propCodemodalStyles}
          onCloseClicked={IsClosePropCodePopup}
        >
          <PropCodeGenerate
            IsClosePropCodePopup={IsClosePropCodePopup}
            propCodeTypes={propCodeTypes}
            generatePropCode={generatePropCode}
            propCodeError={propCodeError}
          />
        </PortalModal>
      )}
    </Fragment>
  );
};
PropCode.propTypes = {
  openMarketPopup: PropTypes.func,
  markets: PropTypes.arrayOf(PropTypes.object),
  setSelProps: PropTypes.func,
  setPropCodeChanged: PropTypes.func,
  reset: PropTypes.bool,
  memriUserDtos: PropTypes.arrayOf(PropTypes.object),
  marketList: PropTypes.arrayOf(PropTypes.object),
  setEditProps: PropTypes.func,
  setPropChanged: PropTypes.func,
  propData: PropTypes.arrayOf(PropTypes.object),
  memriData: PropTypes.arrayOf(PropTypes.object),
  mriMarketData: PropTypes.arrayOf(PropTypes.object),
  editProps: PropTypes.arrayOf(PropTypes.object),
  setNewPropCode: PropTypes.func,
};
export default React.memo(PropCode);
